// Generated file : do not modify
export enum ControleSignatureMasseManqueEtapes
{
  NONE = 0,
  SOCIETE,
  CONTRAT
};

export enum ControleSignatureMasseManqueCodes
{
  NONE = 0,
  HORS_PERIMETRE,
  ETABLISSEMENT_ILLISIBLE,
  IDENTITE_TVA,
  IDENTITE_EFFECTIF,
  SIGNATAIRE_ABSENT,
  SIGNATAIRE_INCOMPLET,
  SALARIE_ABSENT,
  CRENEAUX_MANQUANTS,
  MODELE_A_CHOISIR,
  AUCUN_MODELE,
  OBJET_MANQUANT,
  EMPLOYEUR_INCOMPLET,
  SALARIE_INCOMPLET
};

export enum ResultatContratMasseIssues
{
  NONE = 0,
  ENVOYE,
  IGNORE,
  A_COMPLETER,
  ECHEC,
  APPLIQUE
};

import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Issue d'un contrat dans une action de masse de la signature en lot, avec son motif
export class ControleSignatureMasseQuery {
  // Contrats sélectionnés
  public contratIds: number[];

  constructor() {
    this.contratIds = [];
  }
}

export class ControleSignatureMasseResult {
  // Informations obligatoires manquantes
  public manques: ControleSignatureMasseManque[];

  constructor() {
    this.manques = [];
  }
}

export class ControleSignatureMasseManque {
  // Étape de contrôle
  public etape: ControleSignatureMasseManqueEtapes;
  // Code du manque
  public code: ControleSignatureMasseManqueCodes;
  // Libellé affichable
  public libelle: string;
  // Complétable par l'utilisateur dans le parcours
  public completable: boolean;
  // Établissement concerné
  public etablissementId: number;
  // Contrats bloqués
  public contratIds: number[];
  // Modèles de contrat proposables (manque MODELE_A_CHOISIR)
  public modeleIds: number[];

  constructor() {
    this.etape = ControleSignatureMasseManqueEtapes.NONE;
    this.code = ControleSignatureMasseManqueCodes.NONE;
    this.libelle = '';
    this.completable = false;
    this.etablissementId = 0;
    this.contratIds = [];
    this.modeleIds = [];
  }
}

export class AppliquerObjetCommunQuery {
  // Contrats sélectionnés
  public contratIds: number[];
  // Objet commun à appliquer
  public objet: string;

  constructor() {
    this.contratIds = [];
    this.objet = '';
  }
}

export class AppliquerObjetCommunResult {
  // Nombre de contrats soumis
  public demandes: number;
  // Contrats auxquels l'objet a été appliqué
  public appliques: number;
  // Contrats non concernés : objet déjà renseigné ou contrat non envoyable
  public ignores: number;
  // Contrats en échec
  public echecs: number;
  // Issue de chaque contrat soumis, avec son motif
  public resultats: ResultatContratMasse[];

  constructor() {
    this.demandes = 0;
    this.appliques = 0;
    this.ignores = 0;
    this.echecs = 0;
    this.resultats = [];
  }
}

export class AppliquerModeleContratQuery {
  // Contrats auxquels appliquer le modèle
  public contratIds: number[];
  // Modèle de contrat choisi
  public contratTemplateId: number;

  constructor() {
    this.contratIds = [];
    this.contratTemplateId = 0;
  }
}

export class AppliquerModeleContratResult {
  // Nombre de contrats soumis
  public demandes: number;
  // Contrats auxquels le modèle a été appliqué
  public appliques: number;
  // Contrats non concernés : aucun choix de modèle nécessaire
  public ignores: number;
  // Contrats en échec
  public echecs: number;
  // Issue de chaque contrat soumis, avec son motif
  public resultats: ResultatContratMasse[];

  constructor() {
    this.demandes = 0;
    this.appliques = 0;
    this.ignores = 0;
    this.echecs = 0;
    this.resultats = [];
  }
}

export class EnvoiSignatureMasseQuery {
  // Contrats à envoyer en signature
  public contratIds: number[];

  constructor() {
    this.contratIds = [];
  }
}

export class EnvoiSignatureMasseResult {
  // Nombre de contrats soumis
  public demandes: number;
  // Contrats envoyés en signature électronique
  public envoyes: number;
  // Contrats non envoyés faute d'informations
  public aCompleter: number;
  // Contrats non concernés : déjà envoyés, signés ou non gérés
  public ignores: number;
  // Contrats en échec technique
  public echecs: number;
  // Issue de chaque contrat soumis, avec son motif
  public resultats: ResultatContratMasse[];

  constructor() {
    this.demandes = 0;
    this.envoyes = 0;
    this.aCompleter = 0;
    this.ignores = 0;
    this.echecs = 0;
    this.resultats = [];
  }
}

export default class ResultatContratMasse  {
  // Contrat concerné
  public contratId: number;
  // Issue du contrat
  public issue: ResultatContratMasseIssues;
  // Motif court, affichable ; vide pour un contrat envoyé ou appliqué
  public motif: string;

  constructor() {
    this.contratId = 0;
    this.issue = ResultatContratMasseIssues.NONE;
    this.motif = '';
  }

  public static fromJson (obj: ResultatContratMasse): ResultatContratMasse {
    const newResultatContratMasse: ResultatContratMasse = new ResultatContratMasse();
    newResultatContratMasse.contratId = obj.contratId;
    newResultatContratMasse.issue = obj.issue;
    newResultatContratMasse.motif = obj.motif;
    return newResultatContratMasse;
  }

  public toJsonResultatContratMasse (): string {
    const json = {
      contratId: this.contratId,
      issue: this.issue,
      motif: this.motif,
    }
    return JSON.stringify(json);
  }

  public fromResultatContratMasse (obj: ResultatContratMasse): void {
    this.contratId = obj.contratId;
    this.issue = obj.issue;
    this.motif = obj.motif;
  }

  public compareResultatContratMasse (value: ResultatContratMasse): boolean {
    return (this.toJsonResultatContratMasse() == value.toJsonResultatContratMasse());
  }

  public cloneResultatContratMasse (): ResultatContratMasse {
    return ResultatContratMasse.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(resultatContratMasses: ResultatContratMasse[]) {
  }
}
